
































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import Loading from "@/components/loader/loading.vue";
import { StaffSurveyQuestionOption, StaffSurveySubmission } from "@/api";
import _ from "lodash";

@Component({
  components: {
    Loading,
  },
})
class StaffSumamry extends Vue {
  datePicker = false;
  range: string[] = [];
  loading = false;
  floorId = 0;
  physicianId = 0;
  roomId = 0;
  expanded = [];
  dispatchType = "staff-orientation";
  headers = [
    { text: "Staff Name", value: "staffName" },
    { text: "Department", value: "staffDepartment" },
    { text: "Title", value: "staffTitle" },
    { text: "Date and Time Completed", value: "createdAt" },
    { text: "", value: "data-table-expand" },
  ];
  types = ["staff-orientation", "staff-satisfaction", "staff-exit"];

  async created() {
    this.loading = true;
    this.defaultDates();
    const summary = this.fetchSummary();

    await Promise.all([summary]);
    this.loading = false;
  }

  defaultDates() {
    this.range = [
      moment()
        .startOf("week")
        .format("YYYY-MM-DD"),
      moment()
        .endOf("week")
        .format("YYYY-MM-DD"),
    ];
    this.floorId = 0;
    this.physicianId = 0;
    this.roomId = 0;
  }

  get summary() {
    const stateSummary = this.$store.getters["staffSurvey/summaryList"] || [];
    const list =
      (JSON.parse(JSON.stringify(stateSummary)) as StaffSurveySubmission[]) ||
      [];
    const res: StaffSurveySubmission[] = [];
    _.forEach(list, item => {
      const idatas = _.sortBy(item.surveyData || [], ["order"], ["asc"]);
      const data = item;
      data.surveyData = idatas;
      res.push(data);
    });

    return res;
  }

  get formattedDates() {
    const [date1, date2] = this.range;
    let beginDate = "";
    let endDate = "";
    if (date1 < date2) {
      beginDate = date1;
      endDate = date2;
    } else {
      beginDate = date2;
      endDate = date1;
    }
    const formattedDate = this.range
      ? `${moment(beginDate).format("MMM DD")}  -  ${moment(endDate).format(
          "MMM DD",
        )}`
      : "";
    return formattedDate;
  }

  dateFilterChanged() {
    this.fetchSummary();
  }

  async fetchSummary() {
    await this.$store.dispatch("staffSurvey/getStaffSurveySubmissions", {
      beginAt: this.range[0],
      endAt: this.range[1],
      slug: this.dispatchType,
    });
  }

  formatTableDate(date: string) {
    return moment(date)
      .local()
      .format("MMM D, YYYY | hh:mma");
  }

  updateDispatchType(type: string) {
    this.dispatchType = type;
    this.fetchSummary();
  }

  getOptionLabel(options: StaffSurveyQuestionOption[], optionId: number) {
    if (!options || !optionId) return "Unknown";
    const option = options.find(opt => opt.id === optionId);
    return option ? option.label : "Unknown";
  }
}

export default StaffSumamry;
